import React, { Component } from 'react'
import styles from './index.module.scss'

import { darkmodeListener } from '../../theme';
import { gaSend } from '../../Analytics';

import makeEndpoint from '../../endpoints'

import Button from '../../components/Button'
import Card from '../../components/Card'
import Loading from '../../components/Loading'
import Renderer from '../../components/Renderer'

import icon from '../../components/Login/assets/icon.svg'

import {
  AppConfig,
  UserSession,
  showConnect,
  openContractCall
} from '@stacks/connect';

import {
  uintCV,
  intCV,
  bufferCV,
  stringAsciiCV,
  stringUtf8CV,
  standardPrincipalCV,
  trueCV,
  makeStandardFungiblePostCondition,
  FungibleConditionCode,
  createAssetInfo,
  makeStandardNonFungiblePostCondition,
  NonFungibleConditionCode,
  makeStandardSTXPostCondition
} from '@stacks/transactions';

import { StacksTestnet, StacksMainnet } from '@stacks/network';

import BigNum from 'bn.js'

import InfiniteScroll from 'react-infinite-scroll-component';

import { renderer } from '../../utils'

const testnet = new StacksTestnet();
const mainnet = new StacksMainnet();

const appConfig = new AppConfig(['store_write', 'publish_data']);
const userSession = new UserSession({ appConfig });

type StacksPandasProps = {
  name: string
}

type StacksPandasState = {
  name: string
  contractAddress: string
  contractName: string
  description: string
  image: string
  total: number
  lastTokenID: number
  prices: number
  currency?: string
  saleData: Record<string, any>
  sale: Array<any>
  active: boolean
  paused: boolean
  userData?: any
  offset: number
}

const fetchSize = 25;
class StacksPandas extends Component<StacksPandasProps, StacksPandasState> {
  state = {
    name: "",
    contractAddress: "",
    contractName: "",
    description: "",
    image: "",
    total: 0,
    saleData: {},
    sale: [],
    lastTokenID: 0,
    prices: 0,
    currency: undefined,
    active: false,
    paused: false,
    userData: undefined,
    offset: 1
  }

  componentDidMount() {
    try {
      const userData = localStorage.getItem('userData');
      if (userData) {
        this.setState({
          'userData': JSON.parse(userData)
        })
      }
    } catch {}

    darkmodeListener(styles['theme-light'], styles['theme-dark'])
    fetch(makeEndpoint('/api/drop?name=' + this.props.name))
      .then(res => {
          return res.json()
      })
      .then((artistData) => {
        console.log(artistData)
        this.setState({
          name: artistData.name,
          contractAddress: artistData.contractAddress,
          contractName: artistData.contractName,
          description: artistData.description,
          image: artistData.image,
          total: artistData.total,
          prices: artistData.prices,
          active: artistData.active,
          paused: artistData.paused,
          currency: artistData.currency,
        }, () => {
          var contractName = artistData.contractName.replace('panda-mint', 'panda-nft');
          contractName = contractName.replace('htl-mint', 'htl');
          contractName = contractName.replace('commoners-mint', 'commoners');
          fetch(makeEndpoint('/api/nft/lastTokenID?address='+artistData.contractAddress+'&name='+contractName+'&reload=true'))
          fetch(makeEndpoint('/api/nft/lastTokenID?address='+artistData.contractAddress+'&name='+contractName))
          .then(res => { return res.text() })
          .then((lastTokenStr) => {
            if (lastTokenStr === 'null') {
               return;
            }
            const lastToken = parseInt(lastTokenStr, 10)
            this.setState({
              lastTokenID: lastToken,
            }, () => {
              this.fetchNFTs()
            })
          })
        })
    });
  }

  fetchNFTs() {
    var nfts: Array<any> = []
    var numNFTs = Math.min(this.state.lastTokenID, fetchSize)
    if (this.state.lastTokenID < (this.state.offset + numNFTs)) {
      const diff = (this.state.offset + numNFTs) - this.state.lastTokenID
      numNFTs -= diff;
    }

    var ids = ["1", "226", "358", "618", "729", "514", "372", "106", "594", "455", "383", "492", "187", "68", "37", "822", "140", "132", "465", "472", "135", "497", "342", "519", "824", "168", "393", "36", "758", "467", "498", "768", "517", "836", "181", "532", "231", "328", "559", "441", "575", "507", "687", "479", "270", "841", "534", "93", "558", "12", "882", "130", "570", "433", "109", "550", "560", "289", "295", "251", "436", "178", "605", "165", "201", "574", "175", "470", "173", "739", "401", "493", "379", "27", "704", "735", "572", "386", "314", "64", "695", "679", "3", "82", "808", "179", "44", "491", "458", "180", "530", "855", "38", "838", "157", "883", "75", "275", "281", "420", "249", "602", "490", "613", "206", "4", "801", "300", "194", "845", "191", "282", "176", "97", "72", "405", "555", "244", "475", "49", "521", "586", "252", "478", "345", "844", "214", "351", "688", "540", "795", "207", "724", "524", "408", "396", "789", "774", "869", "99", "593", "407", "95", "701", "354", "71", "339", "874", "428", "184", "580", "25", "298", "577", "260", "392", "223", "680", "563", "398", "642", "294", "20", "141", "705", "7", "87", "718", "18", "599", "812", "573", "215", "538", "453", "146", "544", "338", "879", "854", "740", "105", "488", "102", "397", "113", "276", "39", "81", "619", "792", "167", "798", "370", "221", "617", "362", "325", "843", "80", "196", "753", "564", "402", "713", "790", "446", "159", "316", "188", "496", "461", "104", "210", "658", "267", "59", "504", "451", "624", "341", "870", "421", "125", "674", "694", "311", "212", "482", "272", "193", "791", "380", "462", "162", "23", "147", "334", "350", "263", "352", "309", "315", "518", "634", "662", "643", "471", "692", "511", "297", "675", "813", "646", "100", "863", "630", "153", "411", "360", "723", "73", "101", "569", "163", "463", "810", "513", "213", "788", "216", "313", "268", "346", "456", "142", "205", "717", "610", "454", "248", "278", "90", "359", "742", "840", "228", "711", "238", "347", "797", "585", "415", "331", "773", "849", "620", "545", "349", "500", "337", "145", "413", "652", "741", "481", "438", "128", "614", "531", "752", "356", "865", "271", "301", "734", "583", "728", "261", "236", "762", "121", "14", "754", "802", "292", "154", "819", "22", "826", "807", "307", "327", "816", "659", "139", "269", "533", "53", "89", "427", "8", "647", "527", "596", "689", "136", "722", "96", "499", "811", "340", "632", "127", "225", "571", "170", "169", "79", "653", "444", "369", "333", "501", "287", "848", "414", "666", "842", "273", "604", "412", "785", "430", "330", "832", "389", "115", "678", "766", "185", "76", "324", "198", "13", "875", "217", "149", "117", "224", "16", "440", "503", "51", "732", "520", "784", "395", "681", "448", "302", "590", "567", "432", "426", "50", "468", "672", "486", "32", "265", "839", "15", "831", "782", "835", "66", "536", "284", "464", "237", "552", "29", "304", "381", "60", "644", "466", "387", "775", "144", "579", "787", "344", 
"5", "867", "770", "19", "864", "651", "439", "622", "98", "355", "41", "601", "485", "760", "633", "129", "878", "526", "635", "279", "119", "442", "134", "809", "460", "793", "625", "361", "866", "55", "35", "377", "806", "636", "404", "623", "91", "562", "767", "390", "366", "259", "384", "42", "744", "400", "487", "156", "853", "510", "649", "576", "6", "850", "9", "182", "727", "640", "584", "283", "549", "747", "143", "17", "320", "876", "254", "764", "656", "409", "756", "131", "33", "529", "655", "598", "160", "45", "700", "56", "262", "266", "690", "319", "502", "861", "310", "150", "306", "543", "537", "726", "603", "834", "888", "329", "484", "556", "326", "54", "166", "308", "190", "750", "648", "425", "616", "235", "332", "257", "246", "821", "661", "11", "650", "133", "771", "581", "833", "322", "285", "733", "541", "777", "553", "778", "597", "108", "250", "84", "218", "195", "693", "457", "522", "233", "107", "786", "83", "459", "353", "230", "738", "137", "234", "148", "670", "422", "245", "65", "884", "116", "247", "419", "242", "431", "480", "872", "371", "197", "761", "47", "565", "548", "814", "291", "219", "737", "86", "566", "58", "535", "626", "716", "698", "638", "403", "494", "312", "714", "2", "873", "388", "683", "561", "818", "161", "445", "241", "805", "227", "240", "505", "546", "443", "595", "477", "508", "639", "28", "255", "703", "676", "78", "830", "296", "749", "721", "745", "686", "772", "851", "43", "748", "317", "452", "61", "715", "712", "373", "628", "21", "720", "757", "305", "434", "710", "611", "606", "364", "399", "435", "62", "138", "759", "118", "608", "776", "417", "664", "817", "823", "416", "860", "512", "158", "755", "825", "589", "667", "88", "881", "506", "696", "299", "290", "111", "657", "691", "637", "110", "783", "208", "286", "702", "189", "877", "264", "887", "192", "862", "449", "629", "385", "600", "859", "123", "171", "736", "528", "126", "871", "763", "627", "280", "684", "348", "588", "557", "335", "24", "391", "731", "856", "357", "794", "730", "815", "209", "615", "885", "378", "796", "582", "183", "318", "837", "483", "124", "671", "70", "152", "751", "523", "52", "321", "202", "375", "232", "92", "746", "547", "677", "94", "63", "367", "31", "274", "437", "288", "709", "609", "303", "673", "857", "708", "707", "450", "803", "799", "186", "376", "578", "631", "820", "780", "827", "719", "122", "424", "663", "765", "382", "114", "258", "469", "368", "74", "591", "199", "363", "103", "410", "336", "781", "374", "697", "539", "323", "30", "804", "67", "200", "46", "568", "473", "476", "645", "151", "769", "69", "846", "525", "685", "612", "429", "229", "828", "343", "164", "847", "203", "394", "77", "743", "706", "277", "725", "256", "621", "551", "155", "85", "40", "509", "665", "222", "120", "660", "112", "406", "293", "682", "220", "699", "886", "253", "858", "48", "57", "779", "495", "34", "668", "607", "174", "654", "868", "172", "423", "239", "26", "800", "177", "243", "641", 
"418", "515", "211", "592", "365", "542", "852", "10", "474", "489", "554", "447", "829", "587", "880", "204", "516", "669"];
    var contractName = this.state.contractName.replace('panda-mint', 'panda-nft');
    contractName = contractName.replace('htl-mint', 'htl');
    contractName = contractName.replace('commoners-mint', 'commoners');
    for (var x = this.state.offset; x <= this.state.offset + numNFTs; x++) {
      nfts.push({
        "contractAddress": this.state.contractAddress,
        "tokenID": ids[x],
        "contractName": contractName,
        "sold": true
      });
    }

    var sale: Array<any>  = this.state.sale;
    const filtered_nfts = nfts.filter((r: any) => {
        let filtered_list = sale.filter((l: any) => l.contractAddress == r.contractAddress && l.contractName == r.contractName && String(l.tokenID) == String(r.tokenID));
        return filtered_list.length == 0
    })

    sale.push(...filtered_nfts)
    this.setState({
      'sale': sale
    }, () => {
      this.fetchData(nfts)
    })
  }


  getLength() {
    return this.state.sale.length
  }

  fetchData(nfts: any) {
    for (var nft of nfts) {
      var contractName = nft.contractName.replace('panda-mint', 'panda-nft');
      contractName = contractName.replace('htl-mint', 'htl');
      contractName = contractName.replace('commoners-mint', 'commoners');
      var params = '';
      params += 'address=' + nft.contractAddress;
      params += '&name=' + contractName;
      params += '&id=' + nft.tokenID;
      const nftId = nft.contractAddress + '.' + contractName + ':' + nft.tokenID;
      var saleDataRecord: any = this.state.saleData
      if (saleDataRecord[nftId]) {
          continue;
      }
      fetch(makeEndpoint('/api/nft?' + params))
        .then(res => res.json())
        .then((nftData) => {
          if (nftData.name) {
            var saleData = saleDataRecord;
            saleData[nftId] = nftData;
            this.setState({ saleData });
          }
        })
    }
  }

  getTotal() {
    return this.state.total;
  }

  getAvailable() {
    return this.getTotal() - this.state.lastTokenID;
  }

  getVolumeSold() {
    return this.state.lastTokenID * this.getFloorPrice();
  }

  getFloorPrice() {
    if (!this.state.currency) {
      return (this.state.prices / 1e6);
    } else {
      return this.state.prices;
    }
  }

  nFormatter(num: number, digits: number) {
    const lookup = [
      { value: 1, symbol: "" },
      { value: 1e3, symbol: "K" },
      { value: 1e6, symbol: "M" },
      { value: 1e9, symbol: "B" },
    ];
    const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
    var item = lookup.slice().reverse().find(function(item) {
      return num >= item.value;
    });
    return item ? (num / item.value).toFixed(digits).replace(rx, "$1") + item.symbol : "0";
  }

  renderCard() {
    return this.state.sale.map((x: any) => {
      const saleData: any = this.state.saleData
      const fullData: any = saleData[x.contractAddress + '.' + x.contractName + ':' + x.tokenID]
      if (fullData) {
        return (
          <Card
            renderer={renderer(fullData)}
            collection={fullData.collection || fullData.name}
            name={fullData.name}
            currency={this.state.currency}
            sold={this.state.prices}/>
        )
      }  else if (x.contractName) {
          const titled = x.contractName[0].toUpperCase() + x.contractName.substring(1);
          return (
              <Card
                collection={titled}
                renderer={<Renderer />}
                currency={this.state.currency}
                name={titled + ' #' + x.tokenID}/>
          );
      }
    })
  }


  amount() {
    return this.state.prices
  }

  fiveAmount() {
    return this.state.prices * 5
  }

  tenAmount() {
    return this.state.prices * 10
  }

  mintText() {
    let mintText;
    if (this.state.active && this.state.paused) {
      mintText = 'MINTING CLOSED';
    } else if (!this.state.active) {
      mintText = 'COMING SOON';
    } else if (this.state.lastTokenID >= this.state.total) {
      mintText = "VISIT MARKETPLACE";
    } else if (this.state.userData) {
      mintText = "MINT"
    } else {
      mintText = "CONNECT WALLET TO MINT"
    }
    return mintText
  }

  renderPrice() {
    return (!((this.state.active && this.state.paused) || (!this.state.active) || (this.state.lastTokenID >= this.state.total))) && (this.state.userData)
  }

  stxAddress() {
    if (this.state.userData) {
      const userData: any = this.state.userData
      return userData.profile.stxAddress.mainnet;
    } else {
      return null;
    }
  }

  authenticate() {
        showConnect({
            appDetails: {
                'name': 'Stacks NFT',
                'icon': icon,
            },
            redirectTo: '/',
            onFinish: () => {
                gaSend('User', 'authenticate', 'User Authenticated');
                let userData = userSession.loadUserData();
                this.setState({ userData: userData });
                localStorage.setItem('userData', JSON.stringify(userData));
                window.location.reload();
            },
            userSession: userSession,
        });
    }

  claim(contractAddress: string, contractName: string, salePrice: number, claimNumber: number) {
        const functionArgs: any[] = [];

        let functionName;
        if (claimNumber == 10) {
            functionName = 'claim-ten';
        } else if (claimNumber == 5) {
            functionName = 'claim-five';
        } else {
            functionName = 'claim';
        }

        let standardFungiblePostCondition;
        if (!this.state.currency) {
            standardFungiblePostCondition = makeStandardSTXPostCondition(
                this.stxAddress(),
                FungibleConditionCode.LessEqual,
                new BigNum(salePrice * (claimNumber ?? 1))
            );
        } else if (this.state.currency == 'MIA') {
            const fungibleAssetInfo = createAssetInfo('SP466FNC0P7JWTNM2R9T199QRZN1MYEDTAR0KP27', 'miamicoin-token', 'miamicoin');

            standardFungiblePostCondition = makeStandardFungiblePostCondition(
                this.stxAddress(),
                FungibleConditionCode.LessEqual,
                salePrice,
                fungibleAssetInfo
            );
        }

        const options: any = {
            contractAddress: contractAddress,
            contractName: contractName,
            functionName: functionName,
            network: mainnet,
            functionArgs,
            postConditions: [standardFungiblePostCondition],
            appDetails: {
                'name': 'Stacks NFT',
                'icon': icon,
            },
            onFinish: (data: any) => {
                // this.setState({ 
                //     success: true,
                //     successTransaction: data.txId,
                // });
            },
            onCancel: () => {
                // this.setState({ 
                //     success: false,
                //     errorMessage: "Transaction Failed"
                // });
            }
        };

        openContractCall(options);
    }

  openClaim(contractAddress: string, contractName: string, salePrice: number, tokenID: number) {
      if (this.state.userData) {
          this.claim(contractAddress, contractName, salePrice, tokenID)
      } else {
          this.authenticate()
      }
  }

  mintingBehavior(claimNumber: number) {
        if (this.state.contractAddress && this.state.contractName) {
            if (!this.state.active || this.state.paused) {
                // no op
            } else if (this.state.lastTokenID >= this.state.total) {
                window.location.href = '/marketplace/' + this.state.contractName
            } else {
                this.openClaim(this.state.contractAddress, this.state.contractName, this.state.prices, claimNumber)
            }
        }
    }

  mintButton() {
    if (this.amount() >= 0 && this.renderPrice()) {
      return (
        <Button
          text={this.mintText()}
          price={this.amount()}
          currency={this.state.currency}
          onClick={this.mintingBehavior.bind(this, 1)}/>
      )
    } else {
      return (
        <Button text={this.mintText()}
                onClick={this.mintingBehavior.bind(this, 1)}/>
      )
    }
  }

  nextBlocks(offset: number) {
    this.setState({
      'offset': offset
    }, () => {
      this.fetchNFTs()
    })
  }

  getBlocksNext() {
    this.nextBlocks(this.getLength())
  }

  hasMore() {
    return this.state.lastTokenID > this.state.offset
  }

  render() {
    return (
      <div className={styles.StacksPandas}>
        <div className={styles.MintTopBar}>
          <div className={styles.MintImageBorder}>
            <div className={styles.MintImage}>
              <img
                src={this.state.image}
                height={122}
                width={122}
                className={styles.MintImageSrc}/>
            </div>
          </div>
        </div>
        <div className={styles.MintContent}>
          <div className={styles.MintTitle}>
            {this.state.name}
          </div>
          <div className={styles.MintSummary} dangerouslySetInnerHTML={{__html: this.state.description}}>
          </div>
          <div className={styles.MintButton}>
            {this.mintButton()}
          </div>
          <div className={styles.MintPrice}>
            <div className={styles.MintPriceContainer}>
              <div>
                { this.getTotal().toLocaleString('us') }
              </div>
              <div className={styles.MintPriceTitle}>
                TOTAL
              </div>
            </div>
            <div className={styles.MintPriceContainer}>
              <div>
                { this.getAvailable().toLocaleString('us') }
              </div>
              <div className={styles.MintPriceTitle}>
                REMAINING
              </div>
            </div>
            <div className={styles.MintPriceContainer}>
              <div className={styles.MintPriceIconContainer}>
                {!this.state.currency &&
                  <div className={styles.MintPriceIcon}>
                    <svg width={"15px"} height={"18px"} viewBox={"0 0 15 18"} version={"1.1"} xmlns={"http://www.w3.org/2000/svg"}>
                      <g stroke={"none"} stroke-width={"1"} fill={"none"} fill-rule={"evenodd"}>
                        <g transform={"translate(-889.000000, -497.000000)"} stroke={"#707071"}>
                          <g transform={"translate(528.000000, 492.000000)"}>
                            <g transform={"translate(361.000000, 6.000000)"}>
                              <g>
                                <line x1={"3.84615385"} y1={"6.58823529"} x2={"13.0769231"} y2={"6.58823529"}></line>
                                <line x1={"-9.60769925e-17"} y1={"6.17647059"} x2={"6.15384615"} y2={"6.17647059"} stroke-width={"2"}></line>
                                <line x1={"1.53846154"} y1={"6.17647059"} x2={"6.15384615"} y2={"6.17647059"} stroke-width={"2"} stroke-linecap={"round"}></line>
                                <line x1={"8.46153846"} y1={"6.17647059"} x2={"13.0769231"} y2={"6.17647059"} stroke-width={"2"} stroke-linecap={"round"}></line>
                                <line x1={"8.46153846"} y1={"6.17647059"} x2={"14.6153846"} y2={"6.17647059"} stroke-width={"2"}></line>
                                <line x1={"2.30769231"} y1={"0.411764706"} x2={"6.15384615"} y2={"6.17647059"} stroke-width={"2"} stroke-linejoin={"round"}></line>
                                <line x1={"8.46153846"} y1={"0.411764706"} x2={"12.3076923"} y2={"6.17647059"} stroke-width={"2"} stroke-linejoin={"round"} transform={"translate(10.384615, 3.294118) scale(-1, 1) translate(-10.384615, -3.294118) "}></line>
                              </g>
                              <g transform={"translate(7.500000, 12.500000) scale(1, -1) translate(-7.500000, -12.500000) translate(0.000000, 9.000000)"}>
                                <line x1={"3.84615385"} y1={"6.58823529"} x2={"13.0769231"} y2={"6.58823529"}></line>
                                <line x1={"-9.60769925e-17"} y1={"6.17647059"} x2={"6.15384615"} y2={"6.17647059"} stroke-width={"2"}></line>
                                <line x1={"1.53846154"} y1={"6.17647059"} x2={"6.15384615"} y2={"6.17647059"} stroke-width={"2"} stroke-linecap={"round"}></line>
                                <line x1={"8.46153846"} y1={"6.17647059"} x2={"13.0769231"} y2={"6.17647059"} stroke-width={"2"} stroke-linecap={"round"}></line>
                                <line x1={"8.46153846"} y1={"6.17647059"} x2={"14.6153846"} y2={"6.17647059"} stroke-width={"2"}></line>
                                <line x1={"2.30769231"} y1={"0.411764706"} x2={"6.15384615"} y2={"6.17647059"} stroke-width={"2"} stroke-linejoin={"round"}></line>
                                <line x1={"8.46153846"} y1={"0.411764706"} x2={"12.3076923"} y2={"6.17647059"} stroke-width={"2"} stroke-linejoin={"round"} transform={"translate(10.384615, 3.294118) scale(-1, 1) translate(-10.384615, -3.294118) "}></line>
                              </g>
                            </g>
                          </g>
                        </g>
                      </g>
                    </svg>
                  </div>
                }
                <div>
                  { this.getFloorPrice().toLocaleString('us') }
                </div>
                {this.state.currency == 'MIA' &&
                  <div className={styles.MintPriceText}>
                    MIA
                  </div>
                }
              </div>
              <div className={styles.MintPriceTitle}>
                MINT PRICE
              </div>
            </div>
            <div className={styles.MintPriceContainer}>
              <div className={styles.MintPriceVolumeContainer}>
                { this.nFormatter(this.getVolumeSold(), 3) }
                {this.state.currency == 'MIA' &&
                  <div className={styles.MintPriceText}>
                    MIA
                  </div>
                }
              </div>
              <div className={styles.MintPriceTitle}>
                VOLUME SOLD
              </div>
            </div>
          </div>
        </div>
        <InfiniteScroll
          dataLength={this.getLength()}
          next={this.getBlocksNext.bind(this)}
          hasMore={this.hasMore()}
          loader={<Loading />}
          className={styles.MintPriceCardContainer}
          scrollableTarget={"page-wrapper"}>
          {this.renderCard()}
        </InfiniteScroll>
      </div>
    )
  }
}

export default StacksPandas

